import React from "react";
import CommonRow from "../common-row";
const BigPhotoStoryCardSlider1Ad = props => {
  return <CommonRow {...props} />;
};

export default BigPhotoStoryCardSlider1Ad;
